import { fromJS, List } from 'immutable';
import { handleActions } from 'flux-actions';
import { AppActionTypes } from '../actions/AppActions';
import { UpdatePasswordActionTypes } from '../actions/ProfileActions';
import { UnrecoverableErrorActionTypes } from '../actions/UnrecoverableErrorActions';
const initialState = fromJS({
  updatePassword: undefined,
  unrecoverableErrors: List()
});
function getMessageSafely(error) {
  let message;
  try {
    message = JSON.parse(error.data).message;
  } catch (e) {
    message = error.data;
  }
  return message;
}
export default handleActions({
  [UpdatePasswordActionTypes.SUCCESS](state, action) {
    const error = action.payload.data;
    return state.set('updatePassword', error ? fromJS({
      status: error.status,
      statusText: error.statusText,
      message: getMessageSafely(error)
    }) : undefined);
  },
  [UpdatePasswordActionTypes.FAILURE](state, action) {
    const {
      error
    } = action.payload;
    return state.set('updatePassword', fromJS({
      status: error.status,
      statusText: error.statusText,
      message: getMessageSafely(error)
    }));
  },
  [UpdatePasswordActionTypes.REQUEST](state) {
    return state.set('updatePassword', undefined);
  },
  [AppActionTypes.TOGGLE_CHANGE_PASSWORD_MODAL](state) {
    return state.set('updatePassword', undefined);
  },
  [UnrecoverableErrorActionTypes.CREATE_UNRECOVERABLE_ERROR](state, action) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payload' does not exist on type '{ type:... Remove this comment to see the full error message
    const errorAction = action.payload;
    const {
      error
    } = errorAction.payload;
    return state.set('unrecoverableErrors', state.get('unrecoverableErrors').push(fromJS({
      time: Date.now(),
      type: errorAction.type,
      status: error.status,
      statusText: error.statusText,
      message: getMessageSafely(error)
    })));
  }
}, initialState);